import { FunctionComponent, useEffect, useState } from 'react';
import PageSidebar, { PageSidebarItem } from 'components/PageSidebar';
import PrivatePage from './PrivatePage';
import { faList, faPuzzlePiece, faStar } from '@fortawesome/pro-light-svg-icons';
import { useHistory, useLocation } from 'react-router-dom';
import { MembershipsPath, ServicesPath } from 'routes/Paths';
import MembershipsComponent from 'components/Memberships';
import { membershipMarketplaceIds } from 'utils/MarketplaceConfig';

interface ServicesProps {
    create: string;
}

const PrimaryItem = {
    icon: faList,
    title: 'Primary Services',
    key: 'primary'
};

const AddOnsItem = {
    icon: faPuzzlePiece,
    title: 'Add-Ons',
    key: 'add_ons'
};

const MembershipsItem = {
    icon: faStar,
    title: 'Memberships',
    key: 'memberships',
    exclusiveMarketplaceIds: membershipMarketplaceIds()
};

const sidebarItems: Array<PageSidebarItem> = [PrimaryItem, AddOnsItem, MembershipsItem];

export const Memberships: FunctionComponent<ServicesProps> = props => {
    const location = useLocation();
    const history = useHistory();
    const [selectedKey, setSelectedKey] = useState<string>(MembershipsItem.key);

    const sidebar = (
        <PageSidebar
            title="Services"
            items={sidebarItems}
            selectedKey={selectedKey}
            onSelect={setSelectedKey}
        />
    );

    useEffect(() => {
        if (selectedKey == PrimaryItem.key) {
            history.push(ServicesPath);
        }
        if (selectedKey == AddOnsItem.key) {
            history.push(ServicesPath + '#' + AddOnsItem.key);
        }
        if (selectedKey == MembershipsItem.key) {
            history.push(MembershipsPath);
        }
    }, [selectedKey]);

    return (
        <PrivatePage
            title="Memberships - Cuddles"
            pageName="/memberships"
            pageSidebar={sidebar}
        >
            <MembershipsComponent />
        </PrivatePage>
    );
};

export default Memberships;
